import React from "react";
import IntegratedExternalAgentApp from "../../components/IntegratedExternalAgentApp";

export default function IntegratedHRApp() {
  return <IntegratedExternalAgentApp agent="hr" title="AzentMart AI HR Agent" />;
}
